import React from "react";
import "./VectorEditorComponent.css";

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  ref?: React.MutableRefObject<HTMLDivElement | null>;
  onClickRef?: React.MouseEventHandler<HTMLDivElement>;
};

export default function VectorEditorComponent({ children, style = {}, ref, onClickRef }: Props) {
  return (
    <div onClick={onClickRef} ref={ref} className="vector-editor-component" style={{ ...style }}>
      {children}
    </div>
  );
}
